import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id DBD8C754-85C4-43C4-BEA8-BCFEDB30B382
 * name thermometer-low
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer-low.svg
 * tags
 * - Home Automation 
 * - Weather 
 */
export const ThermometerLowIcon = createSvgIcon(<><path d="M15 13V5A3 3 0 0 0 9 5V13A5 5 0 1 0 15 13M12 4A1 1 0 0 1 13 5V12H11V5A1 1 0 0 1 12 4Z" /></>, 'ThermometerLowIcon');
export default ThermometerLowIcon